// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.lease.LeaseWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  ArchiveLeaseRequestDto,
  CreateNewLeaseForApplicationRequestDto,
  CreateNewLeaseForApplicationResponseDto,
  CreateNewLeaseRequestDto,
  CreateNewLeaseResponseDto,
  GetLeaseResponseDto,
  GetLeaseV2ResponseDto,
} from '../..';

interface DeactivateLeaseParams {
  leaseId: number;
}
interface GetLeaseParams {
  leaseId: number;
}
interface GetLeaseV2Params {
  leaseId: number;
}

export const LeaseWebApiHandler_archiveLease_Path = '/api/web/v1/lease/archiveLease';

/**
 * archive lease for user
 */
export const LeaseWebApiHandler_archiveLease = (postData: ArchiveLeaseRequestDto, client = getClient()) => {
  return httpFrontEndRequest<never, ArchiveLeaseRequestDto, void>(
    {
      endpoint: LeaseWebApiHandler_archiveLease_Path,
      method: 'POST',
      contextPath: '/leasing',
      postData: postData,
    },
    client,
  );
};

export const LeaseWebApiHandler_createNewLease_Path = '/api/web/v1/lease/createNewLease';

/**
 * create new lease
 */
export const LeaseWebApiHandler_createNewLease = (postData: CreateNewLeaseRequestDto, client = getClient()) => {
  return httpFrontEndRequest<never, CreateNewLeaseRequestDto, CreateNewLeaseResponseDto>(
    {
      endpoint: LeaseWebApiHandler_createNewLease_Path,
      method: 'POST',
      contextPath: '/leasing',
      postData: postData,
    },
    client,
  );
};

export const LeaseWebApiHandler_createNewLeaseForApplication_Path = '/api/web/v1/lease/createNewLeaseForApplication';

/**
 * create new lease with tenants set from application
 */
export const LeaseWebApiHandler_createNewLeaseForApplication = (
  postData: CreateNewLeaseForApplicationRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, CreateNewLeaseForApplicationRequestDto, CreateNewLeaseForApplicationResponseDto>(
    {
      endpoint: LeaseWebApiHandler_createNewLeaseForApplication_Path,
      method: 'POST',
      contextPath: '/leasing',
      postData: postData,
    },
    client,
  );
};

export const LeaseWebApiHandler_deactivateLease_Path = '/api/web/v1/lease/deactivateLease';

/**
 * manually deactivate month-to-month lease (move from active to expired)
 */
export const LeaseWebApiHandler_deactivateLease = (getParams: DeactivateLeaseParams, client = getClient()) => {
  return httpFrontEndRequest<DeactivateLeaseParams, never, void>(
    {
      getParams: getParams,
      endpoint: LeaseWebApiHandler_deactivateLease_Path,
      method: 'POST',
      contextPath: '/leasing',
    },
    client,
  );
};

export const LeaseWebApiHandler_getLease_Path = '/api/web/v1/lease/getLease';

/**
 * get lease
 */
export const LeaseWebApiHandler_getLease = (getParams: GetLeaseParams, client = getClient()) => {
  return httpFrontEndRequest<GetLeaseParams, never, GetLeaseResponseDto>(
    {
      getParams: getParams,
      endpoint: LeaseWebApiHandler_getLease_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};

export const LeaseWebApiHandler_getLeaseV2_Path = '/api/web/v1/lease/getLeaseV2';

/**
 * get lease
 */
export const LeaseWebApiHandler_getLeaseV2 = (getParams: GetLeaseV2Params, client = getClient()) => {
  return httpFrontEndRequest<GetLeaseV2Params, never, GetLeaseV2ResponseDto>(
    {
      getParams: getParams,
      endpoint: LeaseWebApiHandler_getLeaseV2_Path,
      method: 'GET',
      contextPath: '/leasing',
    },
    client,
  );
};
